import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  `,
  content: css`
    width: 520px;
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;
    padding: 16px 24px;
    min-width: 520px;

    & > button:first-of-type {
      width: 20px;
      height: 20px;

      & svg {
        width: 16px;
        height: 16px;
      }
    }
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
    width: 100%;
  `,
  selectWrapper: css`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  footer: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
  footerActions: css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  `,
  slotSection: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
